export default "__VITE_ASSET__CXn2w4af__"